import { render, staticRenderFns } from "./StartupsStageChart.vue?vue&type=template&id=35a6be20&"
import script from "./StartupsStageChart.vue?vue&type=script&lang=js&"
export * from "./StartupsStageChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports